import { render, staticRenderFns } from "./HomeDownload.vue?vue&type=template&id=120b8a1d&scoped=true&"
import script from "./HomeDownload.vue?vue&type=script&lang=js&"
export * from "./HomeDownload.vue?vue&type=script&lang=js&"
import style0 from "./HomeDownload.vue?vue&type=style&index=0&id=120b8a1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b8a1d",
  null
  
)

export default component.exports